import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

const PageHeader = ({ icon, eyebrow, title, description, actions }) => (
    <Stack
        direction={{ xs: "column", md: "row" }}
        alignItems={{ xs: "flex-start", md: "center" }}
        justifyContent="space-between"
        spacing={2}
        sx={{ mb: { xs: 3, md: 4 } }}
    >
        <Stack direction="row" spacing={2} alignItems="center">
            {icon && (
                <Box
                    sx={(theme) => ({
                        width: 48,
                        height: 48,
                        borderRadius: 3,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: alpha(theme.palette.primary.main, 0.12),
                        color: "primary.main",
                        flexShrink: 0,
                    })}
                >
                    {icon}
                </Box>
            )}
            <Box>
                {eyebrow && (
                    <Typography
                        variant="overline"
                        color="text.secondary"
                        sx={{ display: "block", mb: 0.5 }}
                    >
                        {eyebrow}
                    </Typography>
                )}
                <Typography variant="h3" component="h1">
                    {title}
                </Typography>
                {description && (
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mt: 0.5, maxWidth: 640 }}
                    >
                        {description}
                    </Typography>
                )}
            </Box>
        </Stack>
        {actions && (
            <Stack direction="row" spacing={1.5} alignItems="center">
                {actions}
            </Stack>
        )}
    </Stack>
);

export default PageHeader;